import { DateTime } from 'luxon';

export const DATE_FORMAT = 'd MMM yyyy, HH:mm';

/** Numeric value for DataGrid sort (chronological, includes time). */
export const dateSortValue = (isoDate: string | null | undefined): number | null => {
  if (!isoDate) {
    return null;
  }
  const dt = DateTime.fromISO(isoDate);
  return dt.isValid ? dt.toMillis() : null;
};

/** Formats a sort value for grid export / clipboard. */
export const formatDateSortValue = (millis: number | null | undefined): string => {
  if (millis == null) {
    return '---';
  }
  return DateTime.fromMillis(millis).toFormat(DATE_FORMAT);
};

export const calculateTicks = (date: string): number => {
  const _date = DateTime.fromISO(date, { zone: 'UTC' });
  const epoch = DateTime.fromISO('0001-01-01T00:00:00.000', { zone: 'UTC' });
  const millisecondsSinceEpoch = _date.diff(epoch).as('milliseconds');
  const ticks = millisecondsSinceEpoch * 10000;
  return ticks;
};

export const formatDate = (date: string | undefined, format: 'ff' | 'd MMM yyyy, HH:mm') => {
  if (!date) return '';
  return DateTime.fromISO(date).toFormat(format);
};

export const getDateRangeText = (data: [string, string | undefined], format: 'ff' | 'd MMM yyyy, HH:mm') => {
  if (!data[0]) return '-';

  const startDate = formatDate(data[0], format);
  const endDate = data[1]
    ? ` - ${formatDate(data[1], format)}`
    : '';

  return `${startDate}${endDate}`;
}